module.exports = __webpack_public_path__ + "img/14.11a18b8d.jpg";